import { Link } from "react-router-dom";
import { Sparkles, Heart, BookOpen, Printer, Star } from "lucide-react";

const week = [
    { day: "Day 1", theme: "Kindness", verse: "Ephesians 4:32 (ESV)", text: "Be kind to one another, tenderhearted, forgiving one another, as God in Christ forgave you.", do: "Write a kind note to someone in your house and leave it on their pillow." },
    { day: "Day 2", theme: "Generosity", verse: "Acts 20:35 (ESV)", text: "It is more blessed to give than to receive.", do: "Pick one toy or piece of clothing in great shape and donate it together as a family." },
    { day: "Day 3", theme: "Forgiveness", verse: "Colossians 3:13 (ESV)", text: "As the Lord has forgiven you, so you also must forgive.", do: "Talk about a time someone hurt you. Pray together for that person and ask Jesus to help you forgive." },
    { day: "Day 4", theme: "Caring for creation", verse: "Genesis 1:31 (ESV)", text: "And God saw everything that he had made, and behold, it was very good.", do: "Take a 'thank you' walk: say a thank-you to God for five things you see in nature." },
    { day: "Day 5", theme: "Welcoming the stranger", verse: "Hebrews 13:2 (ESV)", text: "Do not neglect to show hospitality to strangers, for thereby some have entertained angels unawares.", do: "Bake or buy cookies and bring them to a neighbor you've never met." },
    { day: "Day 6", theme: "Serving", verse: "Mark 10:45 (ESV)", text: "For even the Son of Man came not to be served but to serve, and to give his life as a ransom for many.", do: "Find a chore that's not yours and do it secretly to bless someone." },
    { day: "Day 7", theme: "Worship", verse: "Psalm 100:2 (ESV)", text: "Serve the Lord with gladness! Come into his presence with singing!", do: "Have a family worship time — sing one song, read one Psalm, and pray together." },
];

export default function FamilyPack() {
    return (
        <div data-testid="family-pack-page">
            <section className="border-b-2 border-ink bg-mint/30 print:bg-white">
                <div className="max-w-4xl mx-auto px-5 sm:px-8 py-12">
                    <span className="pill bg-white">
                        <Star className="w-3.5 h-3.5" strokeWidth={2.5} /> Family Devotional Pack
                    </span>
                    <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mt-3">
                        7 Days of Going the Second Mile
                    </h1>
                    <p className="mt-4 text-lg text-ink/80 max-w-2xl">
                        A printable week of ESV Bible verses, family conversations, and Christ-like actions you can do together.
                        Print it, stick it on the fridge, and check off each day as you go.
                    </p>
                    <div className="mt-6 flex flex-wrap gap-3 print:hidden">
                        <button onClick={() => window.print()} className="btn-sticker bg-sun text-ink" data-testid="pack-print-btn">
                            <Printer className="w-5 h-5 mr-2" strokeWidth={2.5} /> Print this page
                        </button>
                        <Link to="/" className="btn-sticker bg-white text-ink">Back home</Link>
                    </div>
                </div>
            </section>

            <section className="max-w-4xl mx-auto px-5 sm:px-8 py-10 space-y-4">
                {week.map((d, i) => (
                    <article key={i} className="card-sticker bg-white p-6" data-testid={`pack-day-${i + 1}`}>
                        <div className="flex flex-wrap items-center gap-2 mb-3">
                            <span className="pill bg-sun">{d.day}</span>
                            <span className="pill bg-mint">{d.theme}</span>
                            <span className="pill bg-white">{d.verse}</span>
                        </div>
                        <blockquote className="border-l-4 border-coral pl-4 italic leading-relaxed mb-3">
                            “{d.text.replace(/[“”]/g, "")}”
                        </blockquote>
                        <p className="flex gap-2"><Heart className="w-5 h-5 text-coral mt-1 shrink-0" strokeWidth={2.5} /> <span><strong>Do together:</strong> {d.do}</span></p>
                        <div className="mt-4 flex items-center gap-2 print:flex">
                            <span className="w-6 h-6 border-2 border-ink rounded-md inline-block" />
                            <span className="text-sm text-ink/60">Done</span>
                        </div>
                    </article>
                ))}
            </section>

            <section className="max-w-3xl mx-auto px-5 sm:px-8 py-12 text-center print:hidden">
                <Sparkles className="w-10 h-10 mx-auto text-coral" strokeWidth={2.5} />
                <p className="mt-3 text-ink/70">Want a fresh lesson every day?</p>
                <Link to="/" className="btn-sticker bg-coral text-white mt-3 inline-flex">
                    <BookOpen className="w-5 h-5 mr-2" strokeWidth={2.5} /> Subscribe (free)
                </Link>
            </section>
        </div>
    );
}
